// extracted by mini-css-extract-plugin
export default {"container":"Profiles_container__3LUat","content":"Profiles_content__hjd0s","dstv_logo":"Profiles_dstv_logo__kn8xc"};